import { render, staticRenderFns } from "./LocationTopCigSales.vue?vue&type=template&id=8cde6982&"
import script from "./LocationTopCigSales.vue?vue&type=script&lang=js&"
export * from "./LocationTopCigSales.vue?vue&type=script&lang=js&"
import style0 from "./LocationTopCigSales.vue?vue&type=style&index=0&id=8cde6982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports